import Hammer from 'hammerjs';

(function($, window) {


  let _slice = [].slice;
  let _toString = {}.toString;

  let Splash = (function() {

    function Splash() {
      this._init.apply(this, arguments);
    }

    Splash.dataName = 'Splash';
    Splash.defaultOptions = {

    };

    Splash.prototype = {
      constructor: Splash,

      _init: function($element, options) {
        this.$element = $element;
        this.$content = $element.find('.js-splash__content');
        this.$textLine = $element.find('.js-splash__line');
        this.$indicator = $element.find('.js-splash__indicator');
        this.$cancelButton = $element.find('.js-splash__cancel');
        this._options = options;
        this._swipeContext = new Hammer(this.$element[0]);
        this._swipeContext.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
        this._isRunningTextAnimation = false;

        this._handleMouseWheel =  this._handleMouseWheel.bind(this);
        this._handleSwipeDown =  this._handleSwipeDown.bind(this);
        this._handleCancelButtonClick = this._handleCancelButtonClick.bind(this);

        this._setup();
      },

      _setup: function() {
        this._beginAnimation().done(() => {
          this._handleCompleteAnimation();
        });

        this._setEvents();
      },

      _setEvents: function() {
        this.$cancelButton.on('click', this._handleCancelButtonClick);
      },

      _removeEvents: function() {
        this.$cancelButton.off('click', this._handleCancelButtonClick);
      },

      _beginAnimation: function() {
        const lineAnimationDefers = [];

        this._isRunningTextAnimation = true;

        this.$textLine.each((index, element) => {
          const defer = $.Deferred();

          $(element).velocity({ opacity: 1 }, {
            duration: 2000,
            delay: 500 + 1500 * index,
            easing: 'easeOutQuad',
            complete: () => {
              this._isRunningTextAnimation = false;
              defer.resolve();
            }
          });

          lineAnimationDefers.push(defer);
        });

        const when = $.when.apply(null, lineAnimationDefers);

        return when;
      },

      _handleCompleteAnimation: function() {
        this.$indicator.addClass('is-shown');
        this.$content.addClass('is-shown');
        this._prepareExit();
      },

      _prepareExit: function() {
        this._swipeContext.on('swipeup', this._handleSwipeDown);
        this.$element.on('wheel mousewheel', this._handleMouseWheel);

        this.$element.css('will-change', 'tranform');
      },

      _handleMouseWheel: function(evt) {

        if(evt.originalEvent.deltaY > 0) {
          this._runHideAnimation();

          this.$element.off('wheel mousewheel', this._handleMouseWheel);
          this._swipeContext.off('swipeup', this._handleSwipeDown);
          this.$cancelButton.off('click', this._handleCancelButtonClick);
        }
      },

      _handleSwipeDown: function() {

        this._runHideAnimation();

        this.$element.off('wheel mousewheel', this._handleMouseWheel);
        this._swipeContext.off('swipeup', this._handleSwipeDown);
        this.$cancelButton.off('click', this._handleCancelButtonClick);
      },

      _handleCancelButtonClick: function(evt) {
        evt.preventDefault();

        if(this._isRunningTextAnimation) {
          this.$textLine.velocity('finish');
        }

        this._runHideAnimation();
        this.$element.off('wheel mousewheel', this._handleMouseWheel);
        this._swipeContext.off('swipeup', this._handleSwipeDown);
        this.$cancelButton.off('click', this._handleCancelButtonClick);
      },

      _runHideAnimation() {
        this.$element.velocity({
          translateY: ['-100%', 0]
        }, {
          duration: 900,
          easing: 'easeInOutCubic',
          complete: () => {
            this.$element.css('will-change', 'auto');
            this._notifyCompleteAnimation();
          },
          display: 'none'
        });
      },

      _notifyCompleteAnimation: function() {
        this.$element.trigger('complete');
      },

      destroy: function() {
        this._removeEvents();

        this.$element.removeData(Splash.dataName);
      }

    };

    return Splash;
  })();

  let methods = {

    init: function(options) {
      options = $.extend(true, {}, Splash.defaultOptions, options);

      this.each(function() {
        let $element = $(this);
        $element.data(Splash.dataName, new Splash($element, options));
      });
    },

    destroy: function() {

      this.each(function() {
        let instance = $(this).data(Splash.dataName);

        if(!instance) {
          return;
        }

        instance.destroy();
      });
    }
  };


  $.fn.splash = function() {

    let args = _slice.call(arguments);

    let first = args[0];

    let rest = args.length > 1 ? _slice.call(arguments, 1) : [];

    if (!first) {
        methods.init.call(this);
    }

    else if($.isPlainObject(first)) {
        methods.init.apply(this, args);
    }

    else if(_toString.call(first) === '[object String]' && (first in methods)) {
        methods[first].apply(this, rest);
    }

    else {
        $.error('Failed to invoke a method or to initialise plugin.');
    }

    return this;
  };

})(jQuery, window);



// WEBPACK FOOTER //
// ./src/js/jquery-plugin/splash.js